// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vuuJsonCell{--group-cell-spacer-width:20px;cursor:pointer;height:var(--row-height);border-right-style:solid;border-right-width:1px;align-items:center;padding-left:20px;line-height:16px;display:inline-flex;position:relative}.vuuJsonCell .vuuToggleIconButton{position:absolute}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___.toString();
